/* #1114 - keep the Selling fast bar in step with the selected variant.
 * product-info only swaps its own list of blocks (Price, Sku, Inventory...) on a
 * variant change, so copy ours out of the same section HTML it already fetched. */
document.addEventListener('DOMContentLoaded', () => {
  if (typeof subscribe !== 'function' || !window.theme?.PUB_SUB_EVENTS) return;

  subscribe(theme.PUB_SUB_EVENTS.variantChange, ({ data }) => {
    const id = `SellingFast-${data.sectionId}`;
    const next = data.html?.getElementById(id);
    const current = document.getElementById(id);
    if (next && current) current.innerHTML = next.innerHTML;
  });
});
